// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LinkToModelDefinitions__modelLinkWrapper__1QxLu{font-size:.75rem;font-weight:500;line-height:normal;margin-left:auto}", "",{"version":3,"sources":["webpack://./src/common/components/LinkToModelDefinitions/LinkToModelDefinitions.css"],"names":[],"mappings":"AAAA,iDACE,gBAAkB,CAElB,eAAgB,CAChB,kBAAmB,CAFnB,gBAGF","sourcesContent":[".modelLinkWrapper {\n  font-size: 0.75rem;\n  margin-left: auto;\n  font-weight: 500;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modelLinkWrapper": "LinkToModelDefinitions__modelLinkWrapper__1QxLu"
};
export default ___CSS_LOADER_EXPORT___;
